import { segment } from '@actions/analytics';
import { evtNameCategoryMap } from '@constants/index';
import { CHECKOUT_STARTED } from '@constants/segment';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { SCHOLARSHIP_TEST_CLICKED } from './constants/segment';

function useDstClickHandlers({ goalSlug, goalUID, goalName, lps }) {
  const router = useRouter();

  const takeTest = useCallback(() => {
    segment.track(
      SCHOLARSHIP_TEST_CLICKED,
      {
        last_primary_source: lps,
        goal_name: goalName,
        goal_uid: goalUID,
        is_reattempt: false
      },
      evtNameCategoryMap.WITHOUT_CATEGORY
    );

    router.push(
      '/goal/[goalSlug]/[goalUID]/scholarship-test',
      `/goal/${goalSlug}/${goalUID}/scholarship-test`
    );
  }, [router, goalUID, goalSlug, goalName, lps]);

  const reTakeTest = useCallback(() => {
    segment.track(
      SCHOLARSHIP_TEST_CLICKED,
      {
        last_primary_source: lps,
        goal_name: goalName,
        goal_uid: goalUID,
        is_reattempt: true
      },
      evtNameCategoryMap.WITHOUT_CATEGORY
    );
    router.push(
      '/goal/[goalSlug]/[goalUID]/scholarship-test',
      `/goal/${goalSlug}/${goalUID}/scholarship-test`
    );
  }, [router, goalUID, goalSlug, goalName, lps]);

  const getScholarship = useCallback(
    (code) => {
      segment.track(
        CHECKOUT_STARTED,
        {
          last_primary_source: lps,
          goal_name: goalName,
          goal_uid: goalUID,
          last_primary_source_section: 'Scholarship Test'
        },
        evtNameCategoryMap.BOTH
      );
      router.push(
        {
          pathname: '/goal/[goalSlug]/[goalUID]/subscribe',
          query: { referral_code: code, show_pricing: true }
        },
        `/goal/${goalSlug}/${goalUID}/subscribe?referral_code=${code}&show_pricing=true`
      );
    },
    [router, goalUID, goalSlug, goalName, lps]
  );

  const viewAttempts = useCallback(
    (quizUID, sessionUID) => {
      router.push(
        '/goal/[goalSlug]/[goalUID]/scholarship-test/[quizUID]/attempts/[sessionUID]',
        `/goal/${goalSlug}/${goalUID}/scholarship-test/${quizUID}/attempts/${sessionUID}`
      );
    },
    [router, goalUID, goalSlug]
  );

  return { takeTest, reTakeTest, getScholarship, viewAttempts };
}

export default useDstClickHandlers;
